import { SxProps, Theme } from "@mui/material/styles";

export function sxEnsureArray(iconButtonSx: SxProps<Theme> | undefined) {
  return Array.isArray(iconButtonSx) ? iconButtonSx : [iconButtonSx];
}
